import { PayloadAction } from '@reduxjs/toolkit';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';

export const baseReducerActions = <T extends BaseStoreInterface>(initialData: T) => ({
  startRequest: (state: T) => {
    state.error = null;
    state.isLoading = true;
  },
  endRequest: (state: T, { payload: { error } }: PayloadAction<Pick<BaseStoreInterface, 'error'>>) => {
    state.error = error;
    state.isLoading = false;
  },
  setLoaded: (state: T, { payload }: PayloadAction<boolean>) => {
    state.isLoading = false;
    if (!state.isLoaded) {
      state.isLoaded = payload;
    }
  },
  setData: (state: T, { payload }: PayloadAction<ResponseDataInterface<T['data']>>) => {
    state.data = payload.data ?? initialData.data;
  },
  reset: (state: T) => {
    state.error = initialData.error;
    state.isLoading = initialData.isLoading;
    state.data = initialData.data;
    state.meta = initialData.meta;
  },
  resetMeta: (state: T) => {
    state.meta = initialData.meta;
  },
  resetErrors: (state: T) => {
    state.error = initialData.error;
  },
});
